import {Deserializable} from "./deserializable.model";

export class SubjectContactNumber {


subject_contact_number_id: number;
subject_contact_phone_number: string;
subject_id: number;

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SubjectContactNumber {
    Object.assign(this, input);

    return this;
  }


}



